import axios from "../../../../components/Api/Axios";
import BackendServices from "../../../../components/Api/BackendService";

export default (auditorId: number, qualificationId: number) =>
  axios.patch(
    `${BackendServices.AUDITOR_SERVICE.AUDITOR}/validateQualification`,
    {
      qualificationId,
      auditorId,
    }
  );
